module.exports = __webpack_public_path__ + "static/slider-perks-img1-a78a55163dcd9b2676cc406a44959b2d.jpeg";